export enum UserType {
  IMPORT = 'import',
  ADMIN = 'admin',
  USER = 'user'
}

export enum ConceptType {
  AREA = 'area',
  PRODUCTION = 'production'
}

export enum TankShapeType {
  CIRCLE = 'circle',
  OCTAGON = 'octagon'
}

export enum TankOriginType {
  TURING = 'turing',
  PROJECT_CUSTOM = 'project_custom'
}

export type TTankTypeShape = TankShapeType

export enum OptimizedObjectShapeType {
  CIRCLE = 'circle',
  OCTAGON = 'octagon',
  CUSTOM = 'custom',
  UNKNOWN = 'unknown'
}

export enum ConceptSectionType {
  PRODUCTION = 'production',
  ADMINISTRATION = 'administration',
  OTHER = 'other'
}

export enum SectionDepartmentType {
  PRODUCTION = 'production',
  HATCHERY = 'hatchery',
  SEA = 'sea'
}

export enum SectionDepartmentWaterType {
  SEAWATER = 'seawater',
  FRESHWATER = 'freshwater',
  UNKNOWN = 'unknown'
}

export enum SectionDepartmentLimitTechnology {
  // O2LIMIT = 'o2limit',
  // CO2LIMIT = 'co2limit',
  // TANLIMIT = 'tanlimit'
  FLOWTHROUGH = 'flowthrough',
  HYBRID = 'hybrid',
  RAS = 'ras'
}

// DataLookupTable
export enum DataLookupTableParentTypeEnum {
  project = 'project',
  concept = 'concept',
  global = 'global',
  organization = 'organization'
}
export type DataLookupTableParentType = keyof typeof DataLookupTableParentTypeEnum

export enum DataLookupTableTypeEnum {
  salinity = 'salinity',
  growth = 'growth',
  temperature = 'temperature',
  fish_price_per_kg = 'fish_price_per_kg',
  fish_price_per_pcs = 'fish_price_per_pcs'
}
export type DataLookupTableType = keyof typeof DataLookupTableTypeEnum

export enum OperationalModel {
  NEXUS = 'nexus',
  AXIOS = 'axios'
}
